import { API } from '../constants/api';

export const devApiUrl = {
  [API.USER]: {
    baseUrl: 'https://api-alpha.pklotcorp.com/v3',
  },
  [API.MOCHI_USER]: {
    baseUrl: 'https://user-api-alpha-mochipay.pklotcorp.com/v1',
    headers: {
      'Mochipay-Client-Id':
        '307e7e9c9434047529e5d7374c60ba4ca5e59ae31e4cb3973e0f12e096112ab6',
    },
  },
  [API.PAYMENT]: {
    baseUrl: 'https://payment-alpha.mochipay.xyz/webview',
  },
  [API.PICKNCHARGE]: {
    baseUrl: 'https://api-alpha.pickncharge.xyz',
    headers: { 'content-type': 'application/x-www-form-urlencoded' },
  },
  [API.CONTACT]: {
    baseUrl: 'https://api-alpha.pklotcorp.com/svc/contact/v1',
  },
  [API.MEDIA_CENTER]: {
    baseUrl: 'https://api-media-center-alpha.pklotcorp.com',
  },
  [API.DPASS]: {
    baseUrl: 'https://api-alpha.pass.credit',
  },
};

export const prodApiUrl = {
  [API.USER]: {
    baseUrl: 'https://api.autopass.xyz/v3/',
  },
  [API.MOCHI_USER]: {
    baseUrl: 'https://user-api.mochipay.xyz/v1',
  },
  [API.PAYMENT]: {
    baseUrl: 'https://payment.mochipay.xyz/webview/',
  },
  [API.PICKNCHARGE]: {
    baseUrl: 'https://api.pickncharge.xyz/',
    headers: { 'content-type': 'application/x-www-form-urlencoded' },
  },
  [API.CONTACT]: {
    baseUrl: 'https://api.autopass.xyz/svc/contact/v1',
  },
  [API.MEDIA_CENTER]: {
    baseUrl: 'https://api-media-center.autopass.xyz',
  },
  [API.DPASS]: {
    baseUrl: 'https://api.pass.credit',
  },
};
